module.exports = __webpack_public_path__ + "static/media/vet.68c55eac.jpg";